import { AdsHelpHint } from "@/components/ads-assistant/AdsAssistantCollapsible";
import { compactInputClass } from "@/components/common/surfaceClasses";

export function AdsAssistantManualIngestQualityFieldset(props: {
  qualityRating: "" | "good" | "bad";
  setQualityRating: (v: "" | "good" | "bad") => void;
  qualityNote: string;
  setQualityNote: (v: string) => void;
  promotedExemplar: boolean;
  setPromotedExemplar: (v: boolean) => void;
}) {
  const {
    qualityRating,
    setQualityRating,
    qualityNote,
    setQualityNote,
    promotedExemplar,
    setPromotedExemplar,
  } = props;

  return (
    <fieldset className="rounded-lg border border-amber-200/80 bg-amber-50/40 px-2 py-2 dark:border-amber-900/60 dark:bg-amber-950/30">
      <legend className="text-[11px] font-medium text-amber-950 px-1 dark:text-amber-200">
        <span className="inline-flex flex-wrap items-baseline gap-1">
          <span>Example quality (marketing / trainer / ads guidance editor)</span>
          <AdsHelpHint label="Good / bad examples">
            Marketing, trainer, or Ads guidance editors see quality labels. Use <strong>good</strong> for posts to
            emulate; <strong>bad</strong> for anti-patterns. The short &quot;why&quot; feeds coaching—be specific.
          </AdsHelpHint>
        </span>
      </legend>
      <div className="mt-1 flex flex-wrap gap-3 text-xs">
        <label className="inline-flex items-center gap-1">
          <input type="radio" name="quality" checked={qualityRating === ""} onChange={() => setQualityRating("")} />
          No label
        </label>
        <label className="inline-flex items-center gap-1">
          <input
            type="radio"
            name="quality"
            checked={qualityRating === "good"}
            onChange={() => setQualityRating("good")}
          />
          Good example
        </label>
        <label className="inline-flex items-center gap-1">
          <input
            type="radio"
            name="quality"
            checked={qualityRating === "bad"}
            onChange={() => setQualityRating("bad")}
          />
          Bad example
        </label>
      </div>
      <input
        className={`mt-2 w-full ${compactInputClass}`}
        placeholder="Why (feeds guidelines)"
        value={qualityNote}
        onChange={(e) => setQualityNote(e.target.value)}
      />
      <label className="mt-2 inline-flex items-center gap-2 text-[11px] text-amber-950 dark:text-amber-200">
        <input type="checkbox" checked={promotedExemplar} onChange={(e) => setPromotedExemplar(e.target.checked)} />
        Promoted exemplar (exempt from retention purge)
      </label>
    </fieldset>
  );
}
